import React from "react"
import { Link } from "gatsby"
import Layout from "../Components/Layout"
import Box from "../Components/Box"
import TopIlliustration from "../assets/images/about-illiustration.jpg"

export default () => (
  <Layout>
    <div className="about-page">
      <Box>
        <h1>Kontaktai</h1>



        <div className="text-container">


          <p>
            Lietuvos statistikos departamento <br />
            Statistikos sklaidos ir komunikacijos skyrius<br />
            tel. (8 5) 236 4888<br />
            el. p. {" "}
            <a href="mailto:info@stat.gov.lt" title="info@stat.gov.lt">
              info@stat.gov.lt
            </a><br />

          </p>

        </div>
      </Box>
    </div>
  </Layout>
)
